import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSignout(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H13C13.5523 21 14 20.5523 14 20C14 19.4477 13.5523 19 13 19H5V5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H5Z"
        fill="currentColor"
      />
      <path
        d="M20.7071 12.7071C21.0976 12.3166 21.0976 11.6834 20.7071 11.2929L17.7071 8.29289C17.3166 7.90237 16.6834 7.90237 16.2929 8.29289C15.9024 8.68342 15.9024 9.31658 16.2929 9.70711L17.5858 11H10C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H17.5858L16.2929 14.2929C15.9024 14.6834 15.9024 15.3166 16.2929 15.7071C16.6834 16.0976 17.3166 16.0976 17.7071 15.7071L20.7071 12.7071Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
